import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=1e585ff2&"
import script from "./CommentItem.vue?vue&type=script&lang=js&"
export * from "./CommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports